export default {
  titleFirst: {
    en: 'REVIEW NOW TO RECEIVE A PERSONALIZED RECOMMENDATION',
  },
  titleThankYou: {
    en: 'THANK YOU FOR YOUR REVIEW!',
  },

  descriptionFirst: {
    en: 'Choose which product to review first, or wait to review later if you prefer',
  },
  descriptionThankYou: {
    en: 'Please review your remaining two products to receive <br/> better recommendations.',
  },
  descriptionThankYouOne: {
    en: 'You have one unrated product left.<br/> Please continue review to make recommendations better.',
  },

  fragranceButtonTitle: {
    en: 'Rate now',
  },
}
